import repository from '@/api/modules/Operations/StockTransfer';
import { makeAction } from '@/store/utils/createCrudModule';

export default {
  state: {
    all_warehouse_transfer: [],
    show_stock_transfer: [],
    get_srf_numlist: [],
  },
  getters: {
    GET_ALL_WAREHOUSE_TRANSFER: state => state.all_warehouse_transfer,
    SHOW_STOCK_TRANSFER:        state => state.show_stock_transfer,
    GET_SRF_NUMLIST:            state => state.get_srf_numlist,
  },
  actions: {
    getAllWarehouseTransfer: makeAction(repository, 'getallwarehousetransfers', 'ALL_WAREHOUSE_TRANSFER'),
    showStockTransfer:       makeAction(repository, 'getstocktransfer', 'STOCK_TRANSFER'),

    getSrfNumlist({ commit, state }) {
      return new Promise((resolve, reject) => {
        if (state.get_srf_numlist.length > 0) { resolve(state.get_srf_numlist); return; }
        repository.getsrfnumlist().then(response => {
          if (response.status === 200) {
            resolve(response);
            commit('SRF_NUMLIST', response.data);
          }
        }).catch(reject);
      });
    },

    storeStockTransfer:      makeAction(repository, 'storestocktransfer'),
    approveStockTransfer:    makeAction(repository, 'approvestocktransfer'),
    getWarehouseItemsInline: makeAction(repository, 'getwarehouseitemsinline'),

    destroyStockTransfer({ commit }, payload) {
      return new Promise((resolve, reject) => {
        repository.destroystocktransfer(payload.id).then(response => {
          if (response.status === 200) resolve(response);
        }).catch(reject);
      });
    },

    updateStockTransfer({ commit }, payload) {
      return new Promise((resolve, reject) => {
        repository.updatestocktransfer(payload.id, payload.params).then(response => {
          if (response.status === 200) resolve(response);
        }).catch(reject);
      });
    },
  },
  mutations: {
    ALL_WAREHOUSE_TRANSFER: (state, data) => { state.all_warehouse_transfer = data; },
    STOCK_TRANSFER:         (state, data) => { state.show_stock_transfer    = data; },
    SRF_NUMLIST:            (state, data) => { state.get_srf_numlist        = data; },
  },
};
